import { Helmet } from 'react-helmet';
import DashboardHeader from './DashboardHeader/DashboardHeader';
import DashboardLastMonths from './DashboardLastMonths/DashboardLastMonths';
import DashboardUsersTable from './DashboardUsersTable/DashboardUsersTable';
// import DashboardWidgetsList from "./DashboardWidgetsList/DashboardWidgetsList"
import DashboardLayout from '../../../../commons/DashboardLayout/DashboardLayout';

export default () => {
  return (
    <>
      <Helmet>
        <title>Tableau de bord</title>
      </Helmet>
      <DashboardLayout>
        <DashboardHeader />
        {/* <DashboardWidgetsList /> */}
        <section className="dashboard__main-row" style={{ marginTop: 'var(--spacing-s)' }}>
          <DashboardUsersTable />
          <DashboardLastMonths />
        </section>
      </DashboardLayout>
    </>
  );
};
